// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-list-container {
    display: flex;
    flex-direction: column;
    min-width: 60rem;
    overflow: hidden;
}

.contact-list__header {
    margin: 1.5rem 4rem;
    display: flex;
    align-items: flex-end;
    height: 4rem;
    line-height: 4rem;
}

.contact-list__search {
    flex-grow: 1;
    margin-left: 3rem;
}

.contact-list__btn-create {
    margin-right: 3rem;
}

.contact-list__header .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 17rem;
}

.contact-list-table {
    margin-top: 1.5rem;
}

.contact-list-table th, td {
    text-align: center;
}

.contact-list__btn-more {
    width: 4rem;
    padding: 0;
    margin: 1rem auto;
}

.contact-list__no-contacts-text {
    margin-top: 1.8rem;
    text-align: center;
    font-weight: 500;
    font-size: 2.3rem;
}
.contacts-list__body {
    overflow: auto;
    height: calc(100vh - 12.6rem);
}

.contacts-list__body.splittered {
    left: 1rem;
    right: 0rem;
}

th.channel-list__messenger-header {
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/ContactList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".contact-list-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 60rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.contact-list__header {\r\n    margin: 1.5rem 4rem;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.contact-list__search {\r\n    flex-grow: 1;\r\n    margin-left: 3rem;\r\n}\r\n\r\n.contact-list__btn-create {\r\n    margin-right: 3rem;\r\n}\r\n\r\n.contact-list__header .btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 17rem;\r\n}\r\n\r\n.contact-list-table {\r\n    margin-top: 1.5rem;\r\n}\r\n\r\n.contact-list-table th, td {\r\n    text-align: center;\r\n}\r\n\r\n.contact-list__btn-more {\r\n    width: 4rem;\r\n    padding: 0;\r\n    margin: 1rem auto;\r\n}\r\n\r\n.contact-list__no-contacts-text {\r\n    margin-top: 1.8rem;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    font-size: 2.3rem;\r\n}\r\n.contacts-list__body {\r\n    overflow: auto;\r\n    height: calc(100vh - 12.6rem);\r\n}\r\n\r\n.contacts-list__body.splittered {\r\n    left: 1rem;\r\n    right: 0rem;\r\n}\r\n\r\nth.channel-list__messenger-header {\r\n    text-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
